import { APIGet, APIPost, APIPut, IAPIResponse, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TProductVendor, TVendorContact } from "redux/reducers/models/product";

export type IVendor = TProductVendor;

interface IGetVendor {
  id?: number;
  search?: string;
}

interface IVendorBody {
  title: string;
  address_line?: string;
  address_line_2?: string;
  city?: string;
  province?: string;
  country?: string;
  postal_code?: string;
  notes?: string;
  email?: string;
  phone?: string;
  contact_name?: string;
  contacts?: TVendorContact[];
}

type IPostVendor = IVendorBody;

interface IPutVendor extends IVendorBody {
  id: number;
}

export async function GetVendor(
  params: IGetVendor,
  useGlobalLoader?: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<TProductVendor[]>> {
  return await APIGet(APIUrl(AdminType.ClientAdmin, "/product/vendor"), params, useGlobalLoader, cancelToken);
}

export async function PostVendor(params: IPostVendor, useGlobalLoader?: boolean): Promise<IAPIResponse<TProductVendor>> {
  return await APIPost(APIUrl(AdminType.ClientAdmin, "/product/vendor"), params, useGlobalLoader);
}

export async function PutVendor(params: IPutVendor, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.ClientAdmin, "/product/vendor"), params, useGlobalLoader);
}
